var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _TableStylingWorkflow;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import { action, computed, makeObservable, observable, ObservableMap, reaction, runInAction } from "mobx";
import filterOutUndefined from "../../Core/filterOutUndefined";
import isDefined from "../../Core/isDefined";
import TerriaError from "../../Core/TerriaError";
import ConstantColorMap from "../../Map/ColorMap/ConstantColorMap";
import ContinuousColorMap from "../../Map/ColorMap/ContinuousColorMap";
import DiscreteColorMap from "../../Map/ColorMap/DiscreteColorMap";
import EnumColorMap from "../../Map/ColorMap/EnumColorMap";
import { allIcons, getMakiIcon } from "../../Map/Icons/Maki/MakiIcons";
import ProtomapsImageryProvider from "../../Map/ImageryProvider/ProtomapsImageryProvider";
import { getName } from "../../ModelMixins/CatalogMemberMixin";
import { ImageryParts, isDataSource } from "../../ModelMixins/MappableMixin";
import TableMixin from "../../ModelMixins/TableMixin";
import { QualitativeColorSchemeOptionRenderer, QuantitativeColorSchemeOptionRenderer } from "../../ReactViews/SelectableDimensions/ColorSchemeOptionRenderer";
import { MarkerOptionRenderer } from "../../ReactViews/SelectableDimensions/MarkerOptionRenderer";
import Icon from "../../Styled/Icon";
import { DEFAULT_DIVERGING, DEFAULT_QUALITATIVE, DEFAULT_SEQUENTIAL, DIVERGING_SCALES, QUALITATIVE_SCALES, SEQUENTIAL_CONTINUOUS_SCALES, SEQUENTIAL_SCALES } from "../../Table/TableColorMap";
import TableColumnType from "../../Table/TableColumnType";
import CommonStrata from "../Definition/CommonStrata";
import updateModelFromJson from "../Definition/updateModelFromJson";
import ViewingControls from "../ViewingControls";

/** The ColorSchemeType is used to change which SelectableDimensions are shown.
 * It is basically the "mode" of the TableStylingWorkflow
 *
 * For example - if we are using "sequential-continuous" - then the dimensions will be shown to configure the following:
 * - Sequential color scales
 * - Minimum/Maximum values
 */

/** Columns/Styles with the following TableColumnTypes will be hidden unless we are showing "advanced" options */
export const ADVANCED_TABLE_COLUMN_TYPES = [TableColumnType.latitude, TableColumnType.longitude, TableColumnType.region, TableColumnType.time];

/** SelectableDimensionWorkflow to set styling options for TableMixin models */
let TableStylingWorkflow = (_class = (_TableStylingWorkflow = class TableStylingWorkflow {
  constructor(item) {
    this.item = item;
    /** This is used to simplify SelectableDimensions available to the user.
     * For example - if equal to `diverging-continuous` - then only Diverging continuous color scales will be presented as options
     * See setColorSchemeTypeFromPalette and setColorSchemeType for how this is set. */
    _initializerDefineProperty(this, "colorSchemeType", _descriptor, this);
    _initializerDefineProperty(this, "styleType", _descriptor2, this);
    /** Which bin is currently open in `binMaximumsSelectableDims` or `enumColorsSelectableDim`.
     * This is used in `SelectableDimensionGroup.onToggle` and `SelectableDimensionGroup.isOpen` to make the groups act like an accordion - so only one bin can be edited at any given time.
     */
    _initializerDefineProperty(this, "openBinIndex", _descriptor3, this);
    _defineProperty(this, "activeStyleDisposer", void 0);
    /** Show advances options
     * - Show all column types in "Data" select
     * - Show "Data type (advanced)" select. This allow user to change column type */
    _initializerDefineProperty(this, "showAdvancedOptions", _descriptor4, this);
    makeObservable(this);
    // We need to reset colorSchemeType every time Table.activeStyle changes
    this.activeStyleDisposer = reaction(() => this.item.activeStyle, () => {
      // If the active style is of "advanced" TableColumnType, then set colorSchemeType to "no-style"
      if (isDefined(this.item.activeTableStyle.colorColumn) && ADVANCED_TABLE_COLUMN_TYPES.includes(this.item.activeTableStyle.colorColumn.type)) {
        runInAction(() => this.colorSchemeType = "no-style");
      } else {
        this.setColorSchemeTypeFromPalette();
      }
    });
    this.setColorSchemeTypeFromPalette();
  }
  onClose() {
    this.activeStyleDisposer();
  }
  get menu() {
    return {
      options: filterOutUndefined([{
        text: this.showAdvancedOptions ? i18next.t("models.tableStyling.hideAdvancedOptions") : i18next.t("models.tableStyling.showAdvancedOptions"),
        onSelect: action(() => {
          this.showAdvancedOptions = !this.showAdvancedOptions;
        })
      }, this.showAdvancedOptions ? {
        text: i18next.t("models.tableStyling.copyUserStratum"),
        onSelect: () => {
          const stratum = JSON.stringify(this.item.strata.get(CommonStrata.user));
          try {
            navigator.clipboard.writeText(JSON.stringify(this.item.strata.get(CommonStrata.user)));
          } catch (e) {
            TerriaError.from(e).raiseError(this.item.terria, "Failed to copy to clipboard. User stratum has been printed to console");
            console.log(stratum);
          }
        },
        disable: !this.showAdvancedOptions
      } : undefined])
    };
  }
  get name() {
    return i18next.t("models.tableStyling.name");
  }
  get icon() {
    return Icon.GLYPHS.layers;
  }
  get footer() {
    return {
      buttonText: i18next.t("models.tableStyling.reset"),
      /** Delete all user strata values for TableColumnTraits and TableStyleTraits for the current activeStyle */
      onClick: action(() => {
        var _this$getTableColumnT, _this$getTableStyleTr;
        (_this$getTableColumnT = this.getTableColumnTraits(CommonStrata.user)) === null || _this$getTableColumnT === void 0 || _this$getTableColumnT.strata.delete(CommonStrata.user);
        (_this$getTableStyleTr = this.getTableStyleTraits(CommonStrata.user)) === null || _this$getTableStyleTr === void 0 || _this$getTableStyleTr.strata.delete(CommonStrata.user);
        this.setColorSchemeTypeFromPalette();
      })
    };
  }

  /** This will look at the current `colorMap` and `colorPalette` to guess which `colorSchemeType` is active.
   * This is because `TableMixin` doesn't have an explicit `"colorSchemeType"` flag - it will choose the appropriate type based on `TableStyleTraits`
   * `colorTraits.colorPalette` is also set here if we are only using `tableColorMap.defaultColorPaletteName`
   */
  setColorSchemeTypeFromPalette() {
    const colorMap = this.tableStyle.colorMap;
    const colorPalette = this.tableStyle.colorTraits.colorPalette;
    const defaultColorPalette = this.tableStyle.tableColorMap.defaultColorPaletteName;
    const colorPaletteWithDefault = colorPalette !== null && colorPalette !== void 0 ? colorPalette : defaultColorPalette;
    this.colorSchemeType = undefined;
    if (colorMap instanceof ConstantColorMap) {
      this.colorSchemeType = "no-style";
    } else if (colorMap instanceof ContinuousColorMap) {
      if (SEQUENTIAL_SCALES.includes(colorPaletteWithDefault) || SEQUENTIAL_CONTINUOUS_SCALES.includes(colorPaletteWithDefault)) {
        this.colorSchemeType = "sequential-continuous";
        if (!colorPalette) {
          var _this$getTableStyleTr2;
          (_this$getTableStyleTr2 = this.getTableStyleTraits(CommonStrata.user)) === null || _this$getTableStyleTr2 === void 0 || _this$getTableStyleTr2.color.setTrait(CommonStrata.user, "colorPalette", DEFAULT_SEQUENTIAL);
        }
      } else if (DIVERGING_SCALES.includes(colorPaletteWithDefault)) {
        this.colorSchemeType = "diverging-continuous";
        if (!colorPalette) {
          var _this$getTableStyleTr3;
          (_this$getTableStyleTr3 = this.getTableStyleTraits(CommonStrata.user)) === null || _this$getTableStyleTr3 === void 0 || _this$getTableStyleTr3.color.setTrait(CommonStrata.user, "colorPalette", DEFAULT_DIVERGING);
        }
      }
    } else if (colorMap instanceof DiscreteColorMap) {
      if (this.tableStyle.colorTraits.binColors && this.tableStyle.colorTraits.binColors.length > 0) {
        this.colorSchemeType = "custom-discrete";
      } else if (SEQUENTIAL_SCALES.includes(colorPaletteWithDefault)) {
        this.colorSchemeType = "sequential-discrete";
        if (!colorPalette) {
          var _this$getTableStyleTr4;
          (_this$getTableStyleTr4 = this.getTableStyleTraits(CommonStrata.user)) === null || _this$getTableStyleTr4 === void 0 || _this$getTableStyleTr4.color.setTrait(CommonStrata.user, "colorPalette", DEFAULT_SEQUENTIAL);
        }
      } else if (DIVERGING_SCALES.includes(colorPaletteWithDefault)) {
        this.colorSchemeType = "diverging-discrete";
        if (!colorPalette) {
          var _this$getTableStyleTr5;
          (_this$getTableStyleTr5 = this.getTableStyleTraits(CommonStrata.user)) === null || _this$getTableStyleTr5 === void 0 || _this$getTableStyleTr5.color.setTrait(CommonStrata.user, "colorPalette", DEFAULT_DIVERGING);
        }
      }
    } else if (colorMap instanceof EnumColorMap && QUALITATIVE_SCALES.includes(colorPaletteWithDefault)) {
      if (this.tableStyle.colorTraits.enumColors && this.tableStyle.colorTraits.enumColors.length > 0) {
        this.colorSchemeType = "custom-qualitative";
      } else {
        this.colorSchemeType = "qualitative";
        if (!colorPalette) {
          var _this$getTableStyleTr6;
          (_this$getTableStyleTr6 = this.getTableStyleTraits(CommonStrata.user)) === null || _this$getTableStyleTr6 === void 0 || _this$getTableStyleTr6.color.setTrait(CommonStrata.user, "colorPalette", DEFAULT_QUALITATIVE);
        }
      }
    }
  }

  /** Handle change on colorType - this is called by the "Type" selectable dimension in `this.colorSchemeSelectableDim` */
  setColorSchemeType(stratumId, id) {
    if (!id) return;
    // Set `activeStyle` trait so the value doesn't change
    this.item.setTrait(stratumId, "activeStyle", this.tableStyle.id);

    // Hide any open bin
    this.openBinIndex.clear();

    // Here we use item.activeTableStyle.colorTraits.colorPalette instead of this.colorPalette because we only want this to be defined, if the trait is defined - we don't care about defaultColorPaletteName
    const colorPalette = this.tableStyle.colorTraits.colorPalette;

    // **Discrete color maps**
    // Reset bins
    if (id === "sequential-discrete" || id === "diverging-discrete") {
      var _this$getTableStyleTr7, _this$getTableStyleTr8, _this$tableStyle$colo;
      this.colorSchemeType = id;
      (_this$getTableStyleTr7 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr7 === void 0 || _this$getTableStyleTr7.color.setTrait(stratumId, "mapType", "bin");
      (_this$getTableStyleTr8 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr8 === void 0 || _this$getTableStyleTr8.color.setTrait(stratumId, "binColors", []);

      // Set numberOfBins according to limits of sequential and diverging color scales:
      // - Sequential is [3,9]
      // - Diverging is [3,11]

      // If numberOfBins is 0 - set to sensible default (7)
      if (this.tableStyle.colorTraits.numberOfBins === 0) {
        var _this$getTableStyleTr9;
        (_this$getTableStyleTr9 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr9 === void 0 || _this$getTableStyleTr9.color.setTrait(stratumId, "numberOfBins", 7);
      } else if (id === "sequential-discrete" && this.tableStyle.tableColorMap.binColors.length > 9) {
        var _this$getTableStyleTr0;
        (_this$getTableStyleTr0 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr0 === void 0 || _this$getTableStyleTr0.color.setTrait(stratumId, "numberOfBins", 9);
      } else if (id === "diverging-discrete" && this.tableStyle.tableColorMap.binColors.length > 11) {
        var _this$getTableStyleTr1;
        (_this$getTableStyleTr1 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr1 === void 0 || _this$getTableStyleTr1.color.setTrait(stratumId, "numberOfBins", 11);
      } else if (this.tableStyle.tableColorMap.binColors.length < 3) {
        var _this$getTableStyleTr10;
        (_this$getTableStyleTr10 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr10 === void 0 || _this$getTableStyleTr10.color.setTrait(stratumId, "numberOfBins", 3);
      }

      // If no user stratum - reset bin maximums
      if (!((_this$tableStyle$colo = this.tableStyle.colorTraits.strata.get(stratumId)) !== null && _this$tableStyle$colo !== void 0 && _this$tableStyle$colo.binMaximums)) {
        this.resetBinMaximums(stratumId);
      }
    }
    // **Continuous color maps**
    else if (id === "sequential-continuous" || id === "diverging-continuous") {
      var _this$getTableStyleTr11;
      this.colorSchemeType = id;
      (_this$getTableStyleTr11 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr11 === void 0 || _this$getTableStyleTr11.color.setTrait(stratumId, "mapType", "continuous");
    }
    // **Qualitative (enum) color maps**
    else if (id === "qualitative") {
      var _this$getTableStyleTr12, _this$getTableStyleTr13;
      this.colorSchemeType = id;
      (_this$getTableStyleTr12 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr12 === void 0 || _this$getTableStyleTr12.color.setTrait(stratumId, "mapType", "enum");
      (_this$getTableStyleTr13 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr13 === void 0 || _this$getTableStyleTr13.color.setTrait(stratumId, "enumColors", []);
    }

    // **No style (constant) color maps**
    else if (id === "no-style") {
      var _this$getTableStyleTr14;
      this.colorSchemeType = id;
      (_this$getTableStyleTr14 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr14 === void 0 || _this$getTableStyleTr14.color.setTrait(stratumId, "mapType", "constant");
    }

    // If the current colorPalette is incompatible with the selected type - change colorPalette to default for the selected type
    if (id === "sequential-continuous" && (!colorPalette || ![...SEQUENTIAL_SCALES, ...SEQUENTIAL_CONTINUOUS_SCALES].includes(colorPalette))) {
      var _this$getTableStyleTr15;
      (_this$getTableStyleTr15 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr15 === void 0 || _this$getTableStyleTr15.color.setTrait(stratumId, "colorPalette", DEFAULT_SEQUENTIAL);
    }
    if (id === "sequential-discrete" && (!colorPalette || !SEQUENTIAL_SCALES.includes(colorPalette))) {
      var _this$getTableStyleTr16;
      (_this$getTableStyleTr16 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr16 === void 0 || _this$getTableStyleTr16.color.setTrait(stratumId, "colorPalette", DEFAULT_SEQUENTIAL);
    }
    if ((id === "diverging-continuous" || id === "diverging-discrete") && (!colorPalette || !DIVERGING_SCALES.includes(colorPalette))) {
      var _this$getTableStyleTr17;
      (_this$getTableStyleTr17 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr17 === void 0 || _this$getTableStyleTr17.color.setTrait(stratumId, "colorPalette", DEFAULT_DIVERGING);
    }
    if (id === "qualitative" && (!colorPalette || !QUALITATIVE_SCALES.includes(colorPalette))) {
      var _this$getTableStyleTr18;
      (_this$getTableStyleTr18 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr18 === void 0 || _this$getTableStyleTr18.color.setTrait(stratumId, "colorPalette", DEFAULT_QUALITATIVE);
    }
  }
  get hasCesiumDataSource() {
    return !!this.item.mapItems.find(d => isDataSource(d) && d.entities.values.length > 0);
  }
  get hasProtomapsImageryProvider() {
    return !!this.item.mapItems.find(d => ImageryParts.is(d) && d.imageryProvider instanceof ProtomapsImageryProvider);
  }

  /** Table Style dimensions:
   * - Dataset (Table models in workbench)
   * - Variable (Table style in model)
   * - TableColumn type (advanced only)
   */
  get tableStyleSelectableDim() {
    // Show point style options if current catalog item has any points showing (or uses ProtomapsImageryProvider)
    const showPointStyles = this.hasCesiumDataSource || this.hasProtomapsImageryProvider;

    // Show point size options if current catalog item has points and any scalar columns
    const showPointSize = this.hasCesiumDataSource && (this.tableStyle.pointSizeColumn || this.item.tableColumns.find(t => t.type === TableColumnType.scalar));

    // Show label style options if current catalog item has points
    const showLabelStyles = this.hasCesiumDataSource;

    // Show trail style options if current catalog item has time-series points
    const showTrailStyles = this.hasCesiumDataSource && this.tableStyle.isTimeVaryingPointsWithId();
    return {
      type: "group",
      id: "data",
      name: i18next.t("models.tableStyling.data.name"),
      selectableDimensions: filterOutUndefined([{
        type: "select",
        id: "dataset",
        name: i18next.t("models.tableStyling.data.selectableDimensions.dataset.name"),
        selectedId: this.item.uniqueId,
        // Find all workbench items which have TableStylingWorkflow
        options: this.item.terria.workbench.items.filter(item => ViewingControls.is(item) && item.viewingControls.find(control => control.id === TableStylingWorkflow.type)).map(item => ({
          id: item.uniqueId,
          name: getName(item)
        })),
        setDimensionValue: (_stratumId, value) => {
          const item = this.item.terria.workbench.items.find(i => i.uniqueId === value);
          if (item && TableMixin.isMixedInto(item)) {
            // Trigger new TableStylingWorkflow
            if (item.viewingControls.find(control => control.id === TableStylingWorkflow.type)) {
              item.terria.selectableDimensionWorkflow = new TableStylingWorkflow(item);
            }
          }
        }
      }, {
        type: "select",
        id: "table-style",
        name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyle.name"),
        selectedId: this.tableStyle.id,
        options: this.item.tableStyles.map(style => ({
          id: style.id,
          name: style.title
        })),
        allowCustomInput: true,
        setDimensionValue: (stratumId, value) => {
          if (!this.item.tableStyles.find(style => style.id === value)) {
            this.getTableStyleTraits(stratumId, value);
          }
          this.item.setTrait(stratumId, "activeStyle", value);
          // Note - the activeStyle reaction in TableStylingWorkflow.constructor handles all side effects
          // The reaction will call this.setColorSchemeTypeFromPalette()
        }
      }, {
        type: "select",
        id: "table-style-type",
        name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.name"),
        selectedId: this.styleType,
        options: filterOutUndefined([{
          id: "fill",
          name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.options.fill.name")
        }, showPointSize ? {
          id: "point-size",
          name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.options.pointSize.name")
        } : undefined, showPointStyles ? {
          id: "point",
          name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.options.point.name")
        } : undefined, {
          id: "outline",
          name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.options.outline.name")
        }, showLabelStyles ? {
          id: "label",
          name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.options.label.name")
        } : undefined, showTrailStyles ? {
          id: "trail",
          name: i18next.t("models.tableStyling.data.selectableDimensions.tableStyleType.options.trail.name")
        } : undefined]),
        setDimensionValue: (_stratumId, value) => {
          if (value === "fill" || value === "point-size" || value === "point" || value === "outline" || value === "trail" || value === "label") this.styleType = value;
        }
      }])
    };
  }

  /** List of color schemes available for given `colorSchemeType` */
  get colorSchemesForType() {
    const type = this.colorSchemeType;
    if (!isDefined(type)) return [];
    if (type === "sequential-continuous") return [...SEQUENTIAL_SCALES, ...SEQUENTIAL_CONTINUOUS_SCALES];
    if (type === "sequential-discrete") return SEQUENTIAL_SCALES;
    if (type === "diverging-discrete" || type === "diverging-continuous") return DIVERGING_SCALES;
    if (type === "qualitative") return QUALITATIVE_SCALES;
    return [];
  }

  /** Color scheme dimensions:
   * - Type (see `this.colorSchemeType`)
   * - Color scheme (see `this.colorSchemesForType`)
   * - Number of bins (for discrete)
   */
  get colorSchemeSelectableDim() {
    var _this$tableStyle$colo2, _this$tableStyle$colo3, _this$tableStyle$colo6, _this$tableStyle$colo7;
    return {
      type: "group",
      id: "fill",
      name: i18next.t("models.tableStyling.fill.name"),
      selectableDimensions: filterOutUndefined([
      // Show "Variable" selector to pick colorColumn if tableStyle ID is different from colorColumn ID
      // OR if we are in advanced mode
      this.tableStyle.id !== ((_this$tableStyle$colo2 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo2 === void 0 ? void 0 : _this$tableStyle$colo2.name) || this.showAdvancedOptions ? {
        type: "select",
        id: "table-color-column",
        name: i18next.t("models.tableStyling.fill.selectableDimensions.tableColorColumn.name"),
        selectedId: (_this$tableStyle$colo3 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo3 === void 0 ? void 0 : _this$tableStyle$colo3.name,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          var _this$tableStyle$colo4, _this$getTableStyleTr19, _this$tableStyle$colo5;
          // Make sure `activeStyle` is set, otherwise it may change when we change `colorColumn`
          this.item.setTrait(stratumId, "activeStyle", this.tableStyle.id);
          const prevColumnType = (_this$tableStyle$colo4 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo4 === void 0 ? void 0 : _this$tableStyle$colo4.type;
          (_this$getTableStyleTr19 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr19 === void 0 || _this$getTableStyleTr19.color.setTrait(stratumId, "colorColumn", value);
          const newColumnType = (_this$tableStyle$colo5 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo5 === void 0 ? void 0 : _this$tableStyle$colo5.type;
          // Reset color palette and color scheme type if color column type has changed
          // For example, if the color column type changes from `scalar` to `enum` - we don't want to still have a `scalar` color palette
          if (prevColumnType !== newColumnType) {
            this.tableStyle.colorTraits.setTrait(stratumId, "colorPalette", undefined);
            this.setColorSchemeTypeFromPalette();
          }
        }
      } : undefined, this.showAdvancedOptions ? {
        type: "select",
        id: "data-type",
        name: i18next.t("models.tableStyling.fill.selectableDimensions.dataType.name"),
        options: Object.keys(TableColumnType).filter(type => type.length > 1).map(colType => ({
          id: colType
        })),
        selectedId: isDefined((_this$tableStyle$colo6 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo6 === void 0 ? void 0 : _this$tableStyle$colo6.type) ? TableColumnType[this.tableStyle.colorColumn.type] : undefined,
        setDimensionValue: (stratumId, id) => {
          var _this$getTableColumnT2;
          (_this$getTableColumnT2 = this.getTableColumnTraits(stratumId)) === null || _this$getTableColumnT2 === void 0 || _this$getTableColumnT2.setTrait(stratumId, "type", id);
          this.setColorSchemeTypeFromPalette();
        }
      } : undefined, this.tableStyle.colorColumn ? {
        type: "select",
        id: "type",
        name: i18next.t("models.tableStyling.fill.selectableDimensions.type.name"),
        undefinedLabel: i18next.t("models.tableStyling.fill.selectableDimensions.type.undefinedLabel"),
        options: filterOutUndefined([{
          id: "no-style",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.noStyle.name")
        }, ...(this.tableStyle.colorColumn.type === TableColumnType.scalar ? [{
          id: "sequential-continuous",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.sequentialContinuous.name")
        }, {
          id: "sequential-discrete",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.sequentialDiscrete.name")
        }, {
          id: "diverging-continuous",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.divergingContinuous.name")
        }, {
          id: "diverging-discrete",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.divergingDiscrete.name")
        }] : []), {
          id: "qualitative",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.qualitative.name")
        },
        // Add options for "custom" color palettes if we are in "custom-qualitative" or "custom-discrete" mode
        this.colorSchemeType === "custom-qualitative" ? {
          id: "custom-qualitative",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.customQualitative.name")
        } : undefined, this.colorSchemeType === "custom-discrete" ? {
          id: "custom-discrete",
          name: i18next.t("models.tableStyling.fill.selectableDimensions.type.options.customDiscrete.name")
        } : undefined]),
        selectedId: this.colorSchemeType,
        setDimensionValue: (stratumId, id) => {
          this.setColorSchemeType(stratumId, id);
        }
      } : undefined, {
        type: "select",
        id: "scheme",
        name: i18next.t("models.tableStyling.fill.selectableDimensions.scheme.name"),
        selectedId: (_this$tableStyle$colo7 = this.tableStyle.colorTraits.colorPalette) !== null && _this$tableStyle$colo7 !== void 0 ? _this$tableStyle$colo7 : this.tableStyle.tableColorMap.defaultColorPaletteName,
        options: this.colorSchemesForType.map(style => ({
          id: style
        })),
        optionRenderer: this.colorSchemeType === "qualitative" ? QualitativeColorSchemeOptionRenderer : QuantitativeColorSchemeOptionRenderer(this.colorSchemeType === "sequential-discrete" || this.colorSchemeType === "diverging-discrete" ? this.tableStyle.tableColorMap.binColors.length : undefined),
        setDimensionValue: (stratumId, id) => {
          var _this$getTableStyleTr20, _this$getTableStyleTr21, _this$getTableStyleTr22;
          (_this$getTableStyleTr20 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr20 === void 0 || _this$getTableStyleTr20.color.setTrait(stratumId, "colorPalette", id);
          (_this$getTableStyleTr21 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr21 === void 0 || _this$getTableStyleTr21.color.setTrait(stratumId, "binColors", []);
          (_this$getTableStyleTr22 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr22 === void 0 || _this$getTableStyleTr22.color.setTrait(stratumId, "enumColors", []);
        }
      },
      // Show "Number of Bins" if in discrete mode
      this.colorSchemeType === "sequential-discrete" || this.colorSchemeType === "diverging-discrete" ? {
        type: "numeric",
        id: "number-of-bins",
        name: i18next.t("models.tableStyling.fill.selectableDimensions.numberOfBins.name"),
        allowUndefined: true,
        min:
        // Sequential and diverging color scales must have at least 3 bins
        this.colorSchemeType === "sequential-discrete" || this.colorSchemeType === "diverging-discrete" ? 3 :
        // Custom color scales only need at least 1
        1,
        max:
        // Sequential discrete color scales support up to 9 bins
        this.colorSchemeType === "sequential-discrete" ? 9 :
        // Diverging discrete color scales support up to 11 bins
        this.colorSchemeType === "diverging-discrete" ? 11 :
        // Custom discrete color scales can be any number of bins
        undefined,
        value: this.tableStyle.colorTraits.numberOfBins,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr23;
          if (!isDefined(value)) return;
          (_this$getTableStyleTr23 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr23 === void 0 || _this$getTableStyleTr23.color.setTrait(stratumId, "numberOfBins", value);
          this.resetBinMaximums(stratumId);
        }
      } : undefined])
    };
  }
  get minimumValueSelectableDim() {
    return {
      type: "numeric",
      id: "min",
      name: i18next.t("models.tableStyling.min.name"),
      max: this.tableStyle.tableColorMap.maximumValue,
      value: this.tableStyle.tableColorMap.minimumValue,
      setDimensionValue: (stratumId, value) => {
        var _this$getTableStyleTr24;
        (_this$getTableStyleTr24 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr24 === void 0 || _this$getTableStyleTr24.color.setTrait(stratumId, "minimumValue", value);
        if (this.colorSchemeType === "sequential-discrete" || this.colorSchemeType === "diverging-discrete" || this.colorSchemeType === "custom-discrete") {
          this.setBinMaximums(stratumId);
        }
      }
    };
  }

  /** Display range dimensions:
   * - Minimum value
   * - Maximum value
   */
  get displayRangeDim() {
    return {
      type: "group",
      id: "display-range",
      name: i18next.t("models.tableStyling.displayRange.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([this.minimumValueSelectableDim, {
        type: "numeric",
        id: "max",
        name: i18next.t("models.tableStyling.displayRange.selectableDimensions.max.name"),
        min: this.tableStyle.tableColorMap.minimumValue,
        value: this.tableStyle.tableColorMap.maximumValue,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr25;
          (_this$getTableStyleTr25 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr25 === void 0 || _this$getTableStyleTr25.color.setTrait(stratumId, "maximumValue", value);
        }
      }, this.item.outlierFilterDimension])
    };
  }

  /** Group to show bins with color, start/stop numbers.
   */
  get binColorDims() {
    return {
      type: "group",
      id: "bins",
      name: i18next.t("models.tableStyling.bins.name"),
      isOpen: false,
      selectableDimensions: [...this.tableStyle.tableColorMap.binMaximums.map((bin, idx) => {
        var _this$tableStyle$tabl;
        return {
          type: "group",
          id: "bin-".concat(idx, "-start"),
          name: getColorPreview((_this$tableStyle$tabl = this.tableStyle.tableColorMap.binColors[idx]) !== null && _this$tableStyle$tabl !== void 0 ? _this$tableStyle$tabl : "#aaa", i18next.t("models.tableStyling.bins.selectableDimensions.start.name", {
            value1: idx === 0 ? this.minimumValueSelectableDim.value : this.tableStyle.tableColorMap.binMaximums[idx - 1],
            value2: bin
          })),
          isOpen: this.openBinIndex.get("fill") === idx,
          onToggle: open => {
            if (open && this.openBinIndex.get("fill") !== idx) {
              runInAction(() => this.openBinIndex.set("fill", idx));
              return true;
            }
          },
          selectableDimensions: [{
            type: "color",
            id: "bin-".concat(idx, "-color"),
            name: i18next.t("models.tableStyling.bins.selectableDimensions.start.selectableDimensions.color.name"),
            value: this.tableStyle.tableColorMap.binColors[idx],
            setDimensionValue: (stratumId, value) => {
              var _this$getTableStyleTr26;
              const binColors = [...this.tableStyle.tableColorMap.binColors];
              if (isDefined(value)) binColors[idx] = value;
              (_this$getTableStyleTr26 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr26 === void 0 || _this$getTableStyleTr26.color.setTrait(stratumId, "binColors", binColors);
              this.colorSchemeType = "custom-discrete";
            }
          }, idx === 0 ? this.minimumValueSelectableDim : {
            type: "numeric",
            id: "bin-".concat(idx, "-start"),
            name: i18next.t("models.tableStyling.bins.selectableDimensions.start.selectableDimensions.start.name"),
            value: this.tableStyle.tableColorMap.binMaximums[idx - 1],
            setDimensionValue: (stratumId, value) => {
              const binMaximums = [...this.tableStyle.tableColorMap.binMaximums];
              if (isDefined(value)) binMaximums[idx - 1] = value;
              this.setBinMaximums(stratumId, binMaximums);
            }
          }, {
            type: "numeric",
            id: "bin-".concat(idx, "-stop"),
            name: i18next.t("models.tableStyling.bins.selectableDimensions.start.selectableDimensions.stop.name"),
            value: bin,
            setDimensionValue: (stratumId, value) => {
              const binMaximums = [...this.tableStyle.tableColorMap.binMaximums];
              if (isDefined(value)) binMaximums[idx] = value;
              this.setBinMaximums(stratumId, binMaximums);
            }
          }]
        };
      }).reverse() // Reverse array of bins to match Legend (descending order)
      ]
    };
  }

  /** Groups to show enum "bins" with colors and value */
  get enumColorDims() {
    var _this$tableStyle$colo0;
    return {
      type: "group",
      id: "colors",
      name: i18next.t("models.tableStyling.colors.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([...this.tableStyle.tableColorMap.enumColors.map((enumCol, idx) => {
        var _enumCol$color, _this$tableStyle$colo8, _this$tableStyle$colo9;
        if (!enumCol.value) return;
        const dims = {
          type: "group",
          id: "enum-".concat(idx, "-start"),
          name: getColorPreview((_enumCol$color = enumCol.color) !== null && _enumCol$color !== void 0 ? _enumCol$color : "#aaa", enumCol.value),
          isOpen: this.openBinIndex.get("fill") === idx,
          onToggle: open => {
            if (open && this.openBinIndex.get("fill") !== idx) {
              runInAction(() => this.openBinIndex.set("fill", idx));
              return true;
            }
          },
          selectableDimensions: [{
            type: "color",
            id: "enum-".concat(idx, "-color"),
            name: i18next.t("models.tableStyling.colors.selectableDimensions.color.name"),
            value: enumCol.color,
            setDimensionValue: (stratumId, value) => {
              this.colorSchemeType = "custom-qualitative";
              this.setEnumColorTrait(stratumId, idx, enumCol.value, value);
            }
          }, {
            type: "select",
            id: "enum-".concat(idx, "-value"),
            name: i18next.t("models.tableStyling.colors.selectableDimensions.value.name"),
            selectedId: enumCol.value,
            // Find unique column values which don't already have an enumCol
            // We prepend the current enumCol.value
            options: [{
              id: enumCol.value
            }, ...((_this$tableStyle$colo8 = (_this$tableStyle$colo9 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo9 === void 0 || (_this$tableStyle$colo9 = _this$tableStyle$colo9.uniqueValues.values) === null || _this$tableStyle$colo9 === void 0 ? void 0 : _this$tableStyle$colo9.filter(value => !this.tableStyle.tableColorMap.enumColors.find(enumCol => enumCol.value === value)).map(id => ({
              id
            }))) !== null && _this$tableStyle$colo8 !== void 0 ? _this$tableStyle$colo8 : [])],
            setDimensionValue: (stratumId, value) => {
              this.colorSchemeType = "custom-qualitative";
              this.setEnumColorTrait(stratumId, idx, value, enumCol.color);
            }
          }, {
            type: "button",
            id: "enum-".concat(idx, "-remove"),
            value: i18next.t("models.tableStyling.colors.selectableDimensions.remove.value"),
            setDimensionValue: stratumId => {
              this.colorSchemeType = "custom-qualitative";
              // Remove element by clearing `value`
              this.setEnumColorTrait(stratumId, idx, undefined, undefined);
            }
          }]
        };
        return dims;
      }),
      // Are there more colors to add (are there more unique values in the column than enumCols)
      // Create "Add" to user can add more
      this.tableStyle.colorColumn && this.tableStyle.tableColorMap.enumColors.filter(col => col.value).length < ((_this$tableStyle$colo0 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo0 === void 0 ? void 0 : _this$tableStyle$colo0.uniqueValues.values.length) ? {
        type: "button",
        id: "enum-add",
        value: i18next.t("models.tableStyling.colors.selectableDimensions.add.value"),
        setDimensionValue: stratumId => {
          var _this$tableStyle$colo1;
          this.colorSchemeType = "custom-qualitative";
          const firstValue = (_this$tableStyle$colo1 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo1 === void 0 ? void 0 : _this$tableStyle$colo1.uniqueValues.values.find(value => !this.tableStyle.tableColorMap.enumColors.find(col => col.value === value));
          if (!isDefined(firstValue)) return;

          // Can we find any unused colors in the colorPalette
          const unusedColor = this.tableStyle.tableColorMap.colorScaleCategorical(this.tableStyle.tableColorMap.enumColors.length + 1).find(col => !this.tableStyle.tableColorMap.enumColors.find(enumColor => enumColor.color === col));
          this.setEnumColorTrait(stratumId, this.tableStyle.tableColorMap.enumColors.length, firstValue, unusedColor !== null && unusedColor !== void 0 ? unusedColor : "#000000");
          this.openBinIndex.set("fill", this.tableStyle.tableColorMap.enumColors.length - 1);
        }
      } : undefined])
    };
  }
  get nullColorDimension() {
    return {
      type: "color",
      id: "null-color",
      name: i18next.t("models.tableStyling.nullColor.name"),
      value: this.tableStyle.colorTraits.nullColor,
      allowUndefined: true,
      setDimensionValue: (stratumId, value) => {
        var _this$getTableStyleTr27;
        (_this$getTableStyleTr27 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr27 === void 0 || _this$getTableStyleTr27.color.setTrait(stratumId, "nullColor", value);
      }
    };
  }
  get outlierColorDimension() {
    var _this$tableStyle$colo10, _this$tableStyle$tabl2;
    return {
      type: "color",
      id: "outlier-color",
      name: i18next.t("models.tableStyling.outlierColor.name"),
      allowUndefined: true,
      value: (_this$tableStyle$colo10 = this.tableStyle.colorTraits.outlierColor) !== null && _this$tableStyle$colo10 !== void 0 ? _this$tableStyle$colo10 : (_this$tableStyle$tabl2 = this.tableStyle.tableColorMap.outlierColor) === null || _this$tableStyle$tabl2 === void 0 ? void 0 : _this$tableStyle$tabl2.toCssHexString(),
      setDimensionValue: (stratumId, value) => {
        var _this$getTableStyleTr28;
        (_this$getTableStyleTr28 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr28 === void 0 || _this$getTableStyleTr28.color.setTrait(stratumId, "outlierColor", value);
      }
    };
  }

  /** Misc table style color dimensions:
   * - Region color
   * - Null color
   * - Outlier color
   */
  get additionalColorDimensions() {
    var _this$tableStyle$colo11, _this$tableStyle$colo12, _this$tableStyle$colo13, _this$tableStyle$tabl3;
    return {
      type: "group",
      id: "additional-colors",
      name: i18next.t("models.tableStyling.additionalColors.name"),
      // Open group by default is no activeStyle is selected
      isOpen: !this.item.activeStyle || this.colorSchemeType === "no-style",
      selectableDimensions: filterOutUndefined([((_this$tableStyle$colo11 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo11 === void 0 ? void 0 : _this$tableStyle$colo11.type) === TableColumnType.region ? {
        type: "color",
        id: "region-color",
        name: i18next.t("models.tableStyling.additionalColors.selectableDimensions.regionColor.name"),
        value: this.tableStyle.colorTraits.regionColor,
        allowUndefined: true,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr29;
          (_this$getTableStyleTr29 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr29 === void 0 || _this$getTableStyleTr29.color.setTrait(stratumId, "regionColor", value);
        }
      } : {
        type: "color",
        id: "null-color",
        name: i18next.t("models.tableStyling.additionalColors.selectableDimensions.nullColor.name"),
        value: this.tableStyle.colorTraits.nullColor,
        allowUndefined: true,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr30;
          (_this$getTableStyleTr30 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr30 === void 0 || _this$getTableStyleTr30.color.setTrait(stratumId, "nullColor", value);
        }
      }, ((_this$tableStyle$colo12 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo12 === void 0 ? void 0 : _this$tableStyle$colo12.type) === TableColumnType.scalar ? {
        type: "color",
        id: "outlier-color",
        name: i18next.t("models.tableStyling.additionalColors.selectableDimensions.outlierColor.name"),
        allowUndefined: true,
        value: (_this$tableStyle$colo13 = this.tableStyle.colorTraits.outlierColor) !== null && _this$tableStyle$colo13 !== void 0 ? _this$tableStyle$colo13 : (_this$tableStyle$tabl3 = this.tableStyle.tableColorMap.outlierColor) === null || _this$tableStyle$tabl3 === void 0 ? void 0 : _this$tableStyle$tabl3.toCssHexString(),
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr31;
          (_this$getTableStyleTr31 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr31 === void 0 || _this$getTableStyleTr31.color.setTrait(stratumId, "outlierColor", value);
        }
      } : undefined])
    };
  }
  get pointSizeDimensions() {
    return {
      type: "group",
      id: "point-size",
      name: i18next.t("models.tableStyling.pointSize.name"),
      isOpen: true,
      selectableDimensions: [{
        type: "select",
        id: "point-size-column",
        name: i18next.t("models.tableStyling.pointSize.selectableDimensions.pointSizeColumn.name"),
        selectedId: this.tableStyle.pointSizeTraits.pointSizeColumn,
        options: this.item.tableColumns.filter(col => col.type === TableColumnType.scalar).map(col => ({
          id: col.name,
          name: col.title
        })),
        allowUndefined: true,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr32;
          (_this$getTableStyleTr32 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr32 === void 0 || _this$getTableStyleTr32.pointSize.setTrait(stratumId, "pointSizeColumn", value);
        }
      }, ...(this.tableStyle.pointSizeColumn ? [{
        type: "numeric",
        id: "point-size-null",
        name: i18next.t("models.tableStyling.pointSize.selectableDimensions.pointSizeNull.name"),
        min: 0,
        value: this.tableStyle.pointSizeTraits.nullSize,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr33;
          (_this$getTableStyleTr33 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr33 === void 0 || _this$getTableStyleTr33.pointSize.setTrait(stratumId, "nullSize", value);
        }
      }, {
        type: "numeric",
        id: "point-sizes-factor",
        name: i18next.t("models.tableStyling.pointSize.selectableDimensions.pointSizesFactor.name"),
        min: 0,
        value: this.tableStyle.pointSizeTraits.sizeFactor,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr34;
          (_this$getTableStyleTr34 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr34 === void 0 || _this$getTableStyleTr34.pointSize.setTrait(stratumId, "sizeFactor", value);
        }
      }, {
        type: "numeric",
        id: "point-size-offset",
        name: i18next.t("models.tableStyling.pointSize.selectableDimensions.pointSizeOffset.name"),
        min: 0,
        value: this.tableStyle.pointSizeTraits.sizeOffset,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr35;
          (_this$getTableStyleTr35 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr35 === void 0 || _this$getTableStyleTr35.pointSize.setTrait(stratumId, "sizeOffset", value);
        }
      }] : [])]
    };
  }

  /** Advanced region mapping - pulled from TableMixin.regionColumnDimensions and TableMixin.regionProviderDimensions
   */
  get advancedRegionMappingDimensions() {
    return {
      type: "group",
      id: "region-mapping",
      name: i18next.t("models.tableStyling.regionMapping.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([this.item.regionColumnDimensions, this.item.regionProviderDimensions])
    };
  }

  /** Advanced table dimensions:
   * - Legend (title, ticks, item titles...)
   * - Style options (title, lat/lon columns)
   * - Time options (column, id columns, spread start/finish time, ...)
   * - Workbench options (show style selector, show disable style/time in workbench, ...)
   * - Variable/Column options (title, units)
   */
  get advancedTableDimensions() {
    var _this$tableStyle$long, _this$tableStyle$lati, _this$tableStyle$time, _this$tableStyle$endT, _this$tableStyle$idCo, _this$tableStyle$colo14, _this$tableStyle$colo15;
    return [{
      type: "group",
      id: "legend",
      name: i18next.t("models.tableStyling.legend.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([{
        type: "text",
        id: "legend-title",
        name: i18next.t("models.tableStyling.legend.selectableDimensions.legendTitle.name"),
        value: this.tableStyle.colorTraits.legend.title,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr36;
          (_this$getTableStyleTr36 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr36 === void 0 || _this$getTableStyleTr36.color.legend.setTrait(stratumId, "title", value);
        }
      }, this.colorSchemeType === "diverging-continuous" || this.colorSchemeType === "sequential-continuous" ? {
        type: "numeric",
        id: "legend-ticks",
        name: i18next.t("models.tableStyling.legend.selectableDimensions.legendTicks.name"),
        min: 2,
        value: this.tableStyle.colorTraits.legendTicks,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr37;
          (_this$getTableStyleTr37 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr37 === void 0 || _this$getTableStyleTr37.color.setTrait(stratumId, "legendTicks", value);
        }
      } : undefined, ...this.tableStyle.colorTraits.legend.items.map((legendItem, idx) => ({
        type: "text",
        id: "legend-".concat(idx, "-title"),
        name: i18next.t("models.tableStyling.legend.selectableDimensions.title.name", {
          index: idx + 1
        }),
        value: legendItem.title,
        setDimensionValue: (stratumId, value) => {
          legendItem.setTrait(stratumId, "title", value);
        }
      }))])
    }, {
      type: "group",
      id: "style-options",
      name: i18next.t("models.tableStyling.styleOptions.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([{
        type: "text",
        id: "style-title",
        name: i18next.t("models.tableStyling.styleOptions.selectableDimensions.styleTitle.name"),
        value: this.tableStyle.title,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr38;
          (_this$getTableStyleTr38 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr38 === void 0 || _this$getTableStyleTr38.setTrait(stratumId, "title", value);
        }
      }, {
        type: "select",
        id: "longitude-column",
        name: i18next.t("models.tableStyling.styleOptions.selectableDimensions.longitudeColumn.name"),
        selectedId: (_this$tableStyle$long = this.tableStyle.longitudeColumn) === null || _this$tableStyle$long === void 0 ? void 0 : _this$tableStyle$long.name,
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr39;
          (_this$getTableStyleTr39 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr39 === void 0 || _this$getTableStyleTr39.setTrait(stratumId, "longitudeColumn", value);
        }
      }, {
        type: "select",
        id: "latitude-column",
        name: i18next.t("models.tableStyling.styleOptions.selectableDimensions.latitudeColumn.name"),
        selectedId: (_this$tableStyle$lati = this.tableStyle.latitudeColumn) === null || _this$tableStyle$lati === void 0 ? void 0 : _this$tableStyle$lati.name,
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr40;
          (_this$getTableStyleTr40 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr40 === void 0 || _this$getTableStyleTr40.setTrait(stratumId, "latitudeColumn", value);
        }
      }])
    }, {
      type: "group",
      id: "time-options",
      name: i18next.t("models.tableStyling.timeOptions.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([{
        type: "select",
        id: "table-time-column",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeColumn.name"),
        selectedId: (_this$tableStyle$time = this.tableStyle.timeColumn) === null || _this$tableStyle$time === void 0 ? void 0 : _this$tableStyle$time.name,
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr41;
          (_this$getTableStyleTr41 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr41 === void 0 || _this$getTableStyleTr41.time.setTrait(stratumId, "timeColumn", value);
        }
      }, {
        type: "select",
        id: "table-end-time-column",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableEndTimeColumn.name"),
        selectedId: (_this$tableStyle$endT = this.tableStyle.endTimeColumn) === null || _this$tableStyle$endT === void 0 ? void 0 : _this$tableStyle$endT.name,
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr42;
          (_this$getTableStyleTr42 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr42 === void 0 || _this$getTableStyleTr42.time.setTrait(stratumId, "endTimeColumn", value);
        }
      }, {
        type: "select-multi",
        id: "table-time-id-columns",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeIdColumns.name"),
        selectedIds: (_this$tableStyle$idCo = this.tableStyle.idColumns) === null || _this$tableStyle$idCo === void 0 ? void 0 : _this$tableStyle$idCo.map(c => c.name),
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr43;
          (_this$getTableStyleTr43 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr43 === void 0 || _this$getTableStyleTr43.time.setTrait(stratumId, "idColumns", value);
        }
      }, {
        type: "checkbox",
        id: "table-time-is-sampled",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeIsSampled.name"),
        options: [{
          id: "true",
          name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeIsSampled.options.true.name")
        }, {
          id: "false",
          name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeIsSampled.options.false.name")
        }],
        selectedId: this.tableStyle.isSampled ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr44;
          (_this$getTableStyleTr44 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr44 === void 0 || _this$getTableStyleTr44.time.setTrait(stratumId, "isSampled", value === "true");
        }
      }, {
        type: "numeric",
        id: "table-time-display-duration",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeDisplayDuration.name"),
        value: this.tableStyle.timeTraits.displayDuration,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr45;
          (_this$getTableStyleTr45 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr45 === void 0 || _this$getTableStyleTr45.time.setTrait(stratumId, "displayDuration", value);
        }
      }, {
        type: "checkbox",
        id: "table-time-spread-start-time",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeSpreadStartTime.name"),
        options: [{
          id: "true",
          name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeSpreadStartTime.options.true.name")
        }, {
          id: "false",
          name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeSpreadStartTime.options.false.name")
        }],
        selectedId: this.tableStyle.timeTraits.spreadStartTime ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr46;
          (_this$getTableStyleTr46 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr46 === void 0 || _this$getTableStyleTr46.time.setTrait(stratumId, "spreadStartTime", value === "true");
        }
      }, {
        type: "checkbox",
        id: "table-time-spread-finish-time",
        name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeSpreadFinishTime.name"),
        options: [{
          id: "true",
          name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeSpreadFinishTime.options.true.name")
        }, {
          id: "false",
          name: i18next.t("models.tableStyling.timeOptions.selectableDimensions.tableTimeSpreadFinishTime.options.false.name")
        }],
        selectedId: this.tableStyle.timeTraits.spreadFinishTime ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr47;
          (_this$getTableStyleTr47 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr47 === void 0 || _this$getTableStyleTr47.time.setTrait(stratumId, "spreadFinishTime", value === "true");
        }
      }])
    }, {
      type: "group",
      id: "workbench-options",
      name: i18next.t("models.tableStyling.workbenchOptions.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([{
        type: "checkbox",
        id: "table-style-enabled",
        name: i18next.t("models.tableStyling.workbenchOptions.selectableDimensions.tableStyleEnalbed.name"),
        options: [{
          id: "true",
          name: i18next.t("models.tableStyling.workbenchOptions.selectableDimensions.tableStyleEnalbed.options.true.name")
        }, {
          id: "false",
          name: i18next.t("models.tableStyling.workbenchOptions.selectableDimensions.tableStyleEnalbed.options.false.name")
        }],
        selectedId: this.item.activeTableStyle.hidden ? "false" : "true",
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr48;
          (_this$getTableStyleTr48 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr48 === void 0 || _this$getTableStyleTr48.setTrait(stratumId, "hidden", value === "false");
        }
      }, {
        type: "checkbox",
        id: "show-disable-style-option",
        name: i18next.t("models.tableStyling.workbenchOptions.selectableDimensions.showDisableStyleOption.name"),
        options: [{
          id: "true"
        }, {
          id: "false"
        }],
        selectedId: this.item.showDisableStyleOption ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          this.item.setTrait(stratumId, "showDisableStyleOption", value === "true");
        }
      }, {
        type: "checkbox",
        id: "show-disable-time-option",
        name: i18next.t("models.tableStyling.workbenchOptions.selectableDimensions.showDisableTimeOption.name"),
        options: [{
          id: "true"
        }, {
          id: "false"
        }],
        selectedId: this.item.showDisableTimeOption ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          this.item.setTrait(stratumId, "showDisableTimeOption", value === "true");
        }
      }, {
        type: "checkbox",
        id: "enable-manual-region-mapping",
        name: i18next.t("models.tableStyling.workbenchOptions.selectableDimensions.enableManualRegionMapping.name"),
        options: [{
          id: "true"
        }, {
          id: "false"
        }],
        selectedId: this.item.enableManualRegionMapping ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          this.item.setTrait(stratumId, "enableManualRegionMapping", value === "true");
        }
      }])
    }, {
      type: "group",
      id: "variable-and-column",
      name: i18next.t("models.tableStyling.variableAndColumn.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([{
        type: "text",
        id: "column-title",
        name: i18next.t("models.tableStyling.variableAndColumn.selectableDimensions.columnTitle.name"),
        value: (_this$tableStyle$colo14 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo14 === void 0 ? void 0 : _this$tableStyle$colo14.title,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableColumnT3;
          (_this$getTableColumnT3 = this.getTableColumnTraits(stratumId)) === null || _this$getTableColumnT3 === void 0 || _this$getTableColumnT3.setTrait(stratumId, "title", value);
        }
      }, {
        type: "text",
        id: "column-units",
        name: i18next.t("models.tableStyling.variableAndColumn.selectableDimensions.columnUnits.name"),
        value: (_this$tableStyle$colo15 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo15 === void 0 ? void 0 : _this$tableStyle$colo15.units,
        setDimensionValue: (stratumId, value) => {
          var _this$getTableColumnT4;
          (_this$getTableColumnT4 = this.getTableColumnTraits(stratumId)) === null || _this$getTableColumnT4 === void 0 || _this$getTableColumnT4.setTrait(stratumId, "units", value);
        }
      }])
    }];
  }
  getStyleDims(title, key, tableStyleMap, getDims, getPreview) {
    var _tableStyleMap$column, _traits$mapType, _traits$mapType2, _traits$enum, _tableStyleMap$column4, _traits$mapType3;
    const traits = tableStyleMap.commonTraits;
    if (!isDefined(traits)) return [];
    return filterOutUndefined([{
      type: "group",
      id: key,
      name: title,
      isOpen: true,
      selectableDimensions: filterOutUndefined([{
        type: "checkbox",
        id: "".concat(key, "-enabled"),
        options: [{
          id: "true"
        }, {
          id: "false"
        }],
        selectedId: traits.enabled ? "true" : "false",
        setDimensionValue: (stratumId, value) => {
          traits.setTrait(stratumId, "enabled", value === "true");
        }
      }, {
        type: "select",
        id: "".concat(key, "-column"),
        name: i18next.t("models.tableStyling.style.selectableDimensions.column.name"),
        selectedId: (_tableStyleMap$column = tableStyleMap.column) === null || _tableStyleMap$column === void 0 ? void 0 : _tableStyleMap$column.name,
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          tableStyleMap.commonTraits.setTrait(stratumId, "column", value);
        }
      }, tableStyleMap.column ? {
        type: "select",
        id: "".concat(key, "-style-type"),
        name: i18next.t("models.tableStyling.style.selectableDimensions.styleType.name"),
        undefinedLabel: i18next.t("models.tableStyling.style.selectableDimensions.styleType.undefinedLabel"),
        options: filterOutUndefined([{
          id: "constant",
          name: i18next.t("models.tableStyling.style.selectableDimensions.styleType.constant.name")
        }, tableStyleMap.column.type === TableColumnType.scalar ? {
          id: "bin",
          name: i18next.t("models.tableStyling.style.selectableDimensions.styleType.bin.name")
        } : undefined, {
          id: "enum",
          name: i18next.t("models.tableStyling.style.selectableDimensions.styleType.enum.name")
        }]),
        selectedId: (_traits$mapType = traits.mapType) !== null && _traits$mapType !== void 0 ? _traits$mapType : tableStyleMap.styleMap.type,
        setDimensionValue: (stratumId, id) => {
          if (id === "bin" || id === "enum" || id === "constant") traits.setTrait(stratumId, "mapType", id);
        }
      } : undefined])
    }, tableStyleMap.column && ((_traits$mapType2 = traits.mapType) !== null && _traits$mapType2 !== void 0 ? _traits$mapType2 : tableStyleMap.styleMap.type) === "enum" ? {
      type: "group",
      id: "".concat(key, "-enum"),
      name: i18next.t("models.tableStyling.style.selectableDimensions.enum.name"),
      isOpen: true,
      selectableDimensions: filterOutUndefined([
      // eslint-disable-next-line no-unsafe-optional-chaining
      ...((_traits$enum = traits.enum) === null || _traits$enum === void 0 ? void 0 : _traits$enum.map((enumPoint, idx) => {
        var _tableStyleMap$common, _enumPoint$value, _tableStyleMap$column2, _tableStyleMap$column3;
        const dims = {
          type: "group",
          id: "".concat(key, "-enum-").concat(idx),
          name: getPreview(tableStyleMap.traitValues.enum[idx], tableStyleMap.traitValues.null, (_tableStyleMap$common = tableStyleMap.commonTraits.enum[idx].value) !== null && _tableStyleMap$common !== void 0 ? _tableStyleMap$common : i18next.t("models.tableStyling.style.selectableDimensions.enum.selectableDimensions.enum.noValue")),
          isOpen: this.openBinIndex.get(key) === idx,
          onToggle: open => {
            if (open && this.openBinIndex.get(key) !== idx) {
              runInAction(() => this.openBinIndex.set(key, idx));
              return true;
            }
          },
          selectableDimensions: [{
            type: "select",
            id: "".concat(key, "-enum-").concat(idx, "-value"),
            name: i18next.t("models.tableStyling.style.selectableDimensions.enum.selectableDimensions.enum.selectableDimensions.value.name"),
            selectedId: (_enumPoint$value = enumPoint.value) !== null && _enumPoint$value !== void 0 ? _enumPoint$value : undefined,
            // Find unique column values which don't already have an enumCol
            // We prepend the current enumCol.value
            options: filterOutUndefined([enumPoint.value ? {
              id: enumPoint.value
            } : undefined, ...((_tableStyleMap$column2 = (_tableStyleMap$column3 = tableStyleMap.column) === null || _tableStyleMap$column3 === void 0 || (_tableStyleMap$column3 = _tableStyleMap$column3.uniqueValues.values) === null || _tableStyleMap$column3 === void 0 ? void 0 : _tableStyleMap$column3.filter(value => !traits.enum.find(enumCol => enumCol.value === value)).map(id => ({
              id
            }))) !== null && _tableStyleMap$column2 !== void 0 ? _tableStyleMap$column2 : [])]),
            setDimensionValue: (stratumId, value) => {
              enumPoint.setTrait(stratumId, "value", value);
            }
          }, ...getDims("".concat(key, "-enum-").concat(idx), tableStyleMap.traits.enum[idx], tableStyleMap.traitValues.null), {
            type: "button",
            id: "".concat(key, "-enum-").concat(idx, "-remove"),
            value: i18next.t("models.tableStyling.style.selectableDimensions.enum.selectableDimensions.enum.selectableDimensions.remove.value"),
            setDimensionValue: stratumId => {
              enumPoint.setTrait(stratumId, "value", null);
            }
          }]
        };
        return dims;
      })),
      // Are there more colors to add (are there more unique values in the column than enumCols)
      // Create "Add" to user can add more

      ((_tableStyleMap$column4 = tableStyleMap.column) === null || _tableStyleMap$column4 === void 0 ? void 0 : _tableStyleMap$column4.uniqueValues.values.filter(v => {
        var _traits$enum2;
        return !((_traits$enum2 = traits.enum) !== null && _traits$enum2 !== void 0 && _traits$enum2.find(col => col.value === v));
      }).length) > 0 ? {
        type: "button",
        id: "".concat(key, "-enum-add"),
        value: i18next.t("models.tableStyling.style.selectableDimensions.enum.selectableDimensions.enum.add.value"),
        setDimensionValue: stratumId => {
          var _tableStyleMap$column5;
          const firstValue = (_tableStyleMap$column5 = tableStyleMap.column) === null || _tableStyleMap$column5 === void 0 ? void 0 : _tableStyleMap$column5.uniqueValues.values.find(value => {
            var _traits$enum3;
            return !((_traits$enum3 = traits.enum) !== null && _traits$enum3 !== void 0 && _traits$enum3.find(col => col.value === value));
          });
          if (!isDefined(firstValue)) return;
          const newModel = traits.addObject(stratumId, "enum");
          if (newModel)
            // Copy over values from null/default traitValues for new enum value
            updateModelFromJson(newModel, stratumId, _objectSpread(_objectSpread({}, tableStyleMap.traitValues.null), {}, {
              value: firstValue
            })).logError("Error while adding `enum` item");
          this.openBinIndex.set(key, traits.enum.length - 1);
        }
      } : undefined])
    } : undefined, tableStyleMap.column && ((_traits$mapType3 = traits.mapType) !== null && _traits$mapType3 !== void 0 ? _traits$mapType3 : tableStyleMap.styleMap.type) === "bin" ? {
      type: "group",
      id: "".concat(key, "-bin"),
      name: i18next.t("models.tableStyling.style.selectableDimensions.bin.name"),
      isOpen: true,
      selectableDimensions: filterOutUndefined([{
        type: "button",
        id: "".concat(key, "-bin-add"),
        value: i18next.t("models.tableStyling.style.selectableDimensions.bin.selectableDimensions.add.value"),
        setDimensionValue: stratumId => {
          const newModel = traits.addObject(stratumId, "bin");
          if (newModel)
            // Copy over values from null/default traitValues for new bin
            updateModelFromJson(newModel, stratumId, tableStyleMap.traitValues.null).logError("Error while adding `bin` item");
          this.openBinIndex.set(key, traits.bin.length - 1);
        }
      }, ...traits.bin.map((bin, idx) => {
        var _bin$maxValue, _traits$bin$maxValue, _traits$bin$maxValue2, _bin$maxValue2;
        const dims = {
          type: "group",
          id: "".concat(key, "-bin-").concat(idx),
          name: getPreview(tableStyleMap.traitValues.bin[idx], tableStyleMap.traitValues.null, !isDefined((_bin$maxValue = bin.maxValue) !== null && _bin$maxValue !== void 0 ? _bin$maxValue : undefined) ? i18next.t("models.tableStyling.style.selectableDimensions.bin.selectableDimensions.bin.noValue") : idx > 0 && isDefined((_traits$bin$maxValue = traits.bin[idx - 1].maxValue) !== null && _traits$bin$maxValue !== void 0 ? _traits$bin$maxValue : undefined) ? i18next.t("models.tableStyling.style.selectableDimensions.bin.selectableDimensions.bin.range", {
            value1: traits.bin[idx - 1].maxValue,
            value2: bin.maxValue
          }) : "".concat(bin.maxValue)),
          isOpen: this.openBinIndex.get(key) === idx,
          onToggle: open => {
            if (open && this.openBinIndex.get(key) !== idx) {
              runInAction(() => this.openBinIndex.set(key, idx));
              return true;
            }
          },
          selectableDimensions: filterOutUndefined([idx > 0 ? {
            type: "numeric",
            id: "".concat(key, "-bin-").concat(idx, "-start"),
            name: i18next.t("models.tableStyling.style.selectableDimensions.bin.selectableDimensions.bin.selectableDimensions.start.name"),
            value: (_traits$bin$maxValue2 = traits.bin[idx - 1].maxValue) !== null && _traits$bin$maxValue2 !== void 0 ? _traits$bin$maxValue2 : undefined,
            setDimensionValue: (stratumId, value) => {
              traits.bin[idx - 1].setTrait(stratumId, "maxValue", value);
            }
          } : undefined, {
            type: "numeric",
            id: "".concat(key, "-bin-").concat(idx, "-stop"),
            name: i18next.t("models.tableStyling.style.selectableDimensions.bin.selectableDimensions.bin.selectableDimensions.stop.name"),
            value: (_bin$maxValue2 = bin.maxValue) !== null && _bin$maxValue2 !== void 0 ? _bin$maxValue2 : undefined,
            setDimensionValue: (stratumId, value) => {
              bin.setTrait(stratumId, "maxValue", value);
            }
          }, ...getDims("".concat(key, "-bin-").concat(idx), tableStyleMap.traits.bin[idx], tableStyleMap.traitValues.null), {
            type: "button",
            id: "".concat(key, "-bin-").concat(idx, "-remove"),
            value: i18next.t("models.tableStyling.style.selectableDimensions.bin.selectableDimensions.bin.selectableDimensions.remove.value"),
            setDimensionValue: stratumId => {
              bin.setTrait(stratumId, "maxValue", null);
            }
          }])
        };
        return dims;
      }).reverse() // Reverse to match legend order
      ])
    } : undefined, {
      type: "group",
      id: "".concat(key, "-null"),
      name: i18next.t("models.tableStyling.style.null.name"),
      isOpen: !tableStyleMap.column || !traits.mapType || traits.mapType === "constant",
      selectableDimensions: getDims("".concat(key, "-null"), tableStyleMap.traits.null, tableStyleMap.traitValues.null)
    }]);
  }
  get markerDims() {
    return this.getStyleDims(i18next.t("models.tableStyling.point.name"), "point", this.tableStyle.pointStyleMap, (id, pointTraits, nullValues) => {
      var _pointTraits$marker, _pointTraits$rotation, _pointTraits$height, _pointTraits$width;
      return filterOutUndefined([
      // Only show marker selection if we have a Cesium data source
      this.hasCesiumDataSource ? {
        type: "select",
        id: "".concat(id, "-marker"),
        name: "<terriatooltip title=\"".concat(i18next.t("models.tableStyling.point.selectableDimensions.marker.name"), "\">").concat(i18next.t("models.tableStyling.point.selectableDimensions.marker.tooltip"), "</terriatooltip>"),
        selectedId: ((_pointTraits$marker = pointTraits.marker) !== null && _pointTraits$marker !== void 0 ? _pointTraits$marker : nullValues.marker) || "point",
        allowUndefined: true,
        allowCustomInput: true,
        options: [...allIcons, "point"].map(icon => ({
          id: icon
        })),
        optionRenderer: MarkerOptionRenderer,
        setDimensionValue: (stratumId, value) => {
          pointTraits.setTrait(stratumId, "marker", value || "point");
        }
      } : undefined,
      // Only show rotation if we have a Cesium data source
      this.hasCesiumDataSource ? {
        type: "numeric",
        id: "".concat(id, "-rotation"),
        name: i18next.t("models.tableStyling.point.selectableDimensions.rotation.name"),
        value: (_pointTraits$rotation = pointTraits.rotation) !== null && _pointTraits$rotation !== void 0 ? _pointTraits$rotation : nullValues.rotation,
        setDimensionValue: (stratumId, value) => {
          pointTraits.setTrait(stratumId, "rotation", value);
        }
      } : undefined, !this.tableStyle.pointSizeColumn ? {
        type: "numeric",
        id: "".concat(id, "-height"),
        name: i18next.t("models.tableStyling.point.selectableDimensions.height.name"),
        value: (_pointTraits$height = pointTraits.height) !== null && _pointTraits$height !== void 0 ? _pointTraits$height : nullValues.height,
        setDimensionValue: (stratumId, value) => {
          pointTraits.setTrait(stratumId, "height", value);
        }
      } : undefined, !this.tableStyle.pointSizeColumn ? {
        type: "numeric",
        id: "".concat(id, "-width"),
        name: i18next.t("models.tableStyling.point.selectableDimensions.width.name"),
        value: (_pointTraits$width = pointTraits.width) !== null && _pointTraits$width !== void 0 ? _pointTraits$width : nullValues.width,
        setDimensionValue: (stratumId, value) => {
          pointTraits.setTrait(stratumId, "width", value);
        }
      } : undefined]);
    }, (point, nullValue, label) => {
      var _point$rotation, _getMakiIcon, _point$marker;
      return "<div><img height=\"".concat(24, "px\" style=\"margin-bottom: -4px; transform: rotate(", (_point$rotation = point.rotation) !== null && _point$rotation !== void 0 ? _point$rotation : 0, "deg)\" src=\"").concat((_getMakiIcon = getMakiIcon((_point$marker = point.marker) !== null && _point$marker !== void 0 ? _point$marker : nullValue.marker, "#fff", 1, "#000", 24, 24)) !== null && _getMakiIcon !== void 0 ? _getMakiIcon : point.marker, "\"></img> ").concat(label, "</div>");
    });
  }
  get outlineDims() {
    return this.getStyleDims(i18next.t("models.tableStyling.outline.name"), "outline", this.tableStyle.outlineStyleMap, (id, outlineTraits, nullValues) => {
      var _outlineTraits$color, _outlineTraits$width;
      return [{
        type: "color",
        id: "".concat(id, "-color"),
        name: i18next.t("models.tableStyling.outline.selectableDimensions.color.name"),
        allowUndefined: true,
        value: (_outlineTraits$color = outlineTraits.color) !== null && _outlineTraits$color !== void 0 ? _outlineTraits$color : nullValues.color,
        setDimensionValue: (stratumId, value) => {
          outlineTraits.setTrait(stratumId, "color", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-width"),
        name: i18next.t("models.tableStyling.outline.selectableDimensions.width.name"),
        value: (_outlineTraits$width = outlineTraits.width) !== null && _outlineTraits$width !== void 0 ? _outlineTraits$width : nullValues.width,
        setDimensionValue: (stratumId, value) => {
          outlineTraits.setTrait(stratumId, "width", value);
        }
      }];
    }, (outline, nullValue, label) => {
      var _ref, _outline$color;
      return getColorPreview((_ref = (_outline$color = outline.color) !== null && _outline$color !== void 0 ? _outline$color : nullValue.color) !== null && _ref !== void 0 ? _ref : "#aaa", label);
    });
  }
  get labelDims() {
    return this.getStyleDims(i18next.t("models.tableStyling.label.name"), "label", this.tableStyle.labelStyleMap, (id, labelTraits, nullValues) => {
      var _labelTraits$labelCol, _labelTraits$font, _labelTraits$style, _labelTraits$scale, _labelTraits$fillColo, _labelTraits$outlineC, _labelTraits$outlineW, _labelTraits$horizont, _labelTraits$vertical, _labelTraits$pixelOff, _labelTraits$pixelOff2;
      return filterOutUndefined([{
        type: "select",
        id: "".concat(id, "-column"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.column.name"),
        selectedId: (_labelTraits$labelCol = labelTraits.labelColumn) !== null && _labelTraits$labelCol !== void 0 ? _labelTraits$labelCol : nullValues.labelColumn,
        allowUndefined: true,
        options: this.item.tableColumns.map(col => ({
          id: col.name,
          name: col.title
        })),
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "labelColumn", value);
        }
      }, {
        type: "text",
        id: "".concat(id, "-font"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.font.name"),
        value: (_labelTraits$font = labelTraits.font) !== null && _labelTraits$font !== void 0 ? _labelTraits$font : nullValues.font,
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "font", value);
        }
      }, {
        type: "select",
        id: "".concat(id, "-style"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.style.name"),
        selectedId: (_labelTraits$style = labelTraits.style) !== null && _labelTraits$style !== void 0 ? _labelTraits$style : nullValues.style,
        options: [{
          id: "FILL",
          name: i18next.t("models.tableStyling.label.selectableDimensions.style.options.fill.name")
        }, {
          id: "OUTLINE",
          name: i18next.t("models.tableStyling.label.selectableDimensions.style.options.outline.name")
        }, {
          id: "FILL_AND_OUTLINE",
          name: i18next.t("models.tableStyling.label.selectableDimensions.style.options.fillAndOutline.name")
        }],
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "style", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-scale"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.scale.name"),
        value: (_labelTraits$scale = labelTraits.scale) !== null && _labelTraits$scale !== void 0 ? _labelTraits$scale : nullValues.scale,
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "scale", value);
        }
      },
      // Show style traits depending on `style`
      // three options "FILL", "FILL_AND_OUTLINE" and "OUTLINE"
      labelTraits.style === "FILL" || labelTraits.style === "FILL_AND_OUTLINE" ? {
        type: "color",
        id: "".concat(id, "-fill-color"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.fillColor.name"),
        value: (_labelTraits$fillColo = labelTraits.fillColor) !== null && _labelTraits$fillColo !== void 0 ? _labelTraits$fillColo : nullValues.fillColor,
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "fillColor", value);
        }
      } : undefined, labelTraits.style === "OUTLINE" || labelTraits.style === "FILL_AND_OUTLINE" ? {
        type: "color",
        id: "".concat(id, "-outline-color"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.outlineColor.name"),
        value: (_labelTraits$outlineC = labelTraits.outlineColor) !== null && _labelTraits$outlineC !== void 0 ? _labelTraits$outlineC : nullValues.outlineColor,
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "outlineColor", value);
        }
      } : undefined, labelTraits.style === "OUTLINE" || labelTraits.style === "FILL_AND_OUTLINE" ? {
        type: "numeric",
        id: "".concat(id, "-outline-width"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.outlineWidth.name"),
        value: (_labelTraits$outlineW = labelTraits.outlineWidth) !== null && _labelTraits$outlineW !== void 0 ? _labelTraits$outlineW : nullValues.outlineWidth,
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "outlineWidth", value);
        }
      } : undefined, {
        type: "select",
        id: "".concat(id, "-horizontal-origin"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.horizontalOrigin.name"),
        selectedId: (_labelTraits$horizont = labelTraits.horizontalOrigin) !== null && _labelTraits$horizont !== void 0 ? _labelTraits$horizont : nullValues.horizontalOrigin,
        options: [{
          id: "LEFT",
          name: i18next.t("models.tableStyling.label.selectableDimensions.horizontalOrigin.options.left.name")
        }, {
          id: "CENTER",
          name: i18next.t("models.tableStyling.label.selectableDimensions.horizontalOrigin.options.center.name")
        }, {
          id: "RIGHT",
          name: i18next.t("models.tableStyling.label.selectableDimensions.horizontalOrigin.options.right.name")
        }],
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "horizontalOrigin", value);
        }
      }, {
        type: "select",
        id: "".concat(id, "-vertical-origin"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.verticalOrigin.name"),
        selectedId: (_labelTraits$vertical = labelTraits.verticalOrigin) !== null && _labelTraits$vertical !== void 0 ? _labelTraits$vertical : nullValues.verticalOrigin,
        options: [{
          id: "TOP",
          name: i18next.t("models.tableStyling.label.selectableDimensions.verticalOrigin.options.top.name")
        }, {
          id: "CENTER",
          name: i18next.t("models.tableStyling.label.selectableDimensions.verticalOrigin.options.center.name")
        }, {
          id: "BASELINE",
          name: i18next.t("models.tableStyling.label.selectableDimensions.verticalOrigin.options.baseline.name")
        }, {
          id: "BOTTOM",
          name: i18next.t("models.tableStyling.label.selectableDimensions.verticalOrigin.options.bottom.name")
        }],
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "verticalOrigin", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-pixel-offset-x"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.offsetX.name"),
        value: (_labelTraits$pixelOff = labelTraits.pixelOffset[0]) !== null && _labelTraits$pixelOff !== void 0 ? _labelTraits$pixelOff : nullValues.pixelOffset[0],
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "pixelOffset", [value !== null && value !== void 0 ? value : 0, labelTraits.pixelOffset[1]]);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-pixel-offset-y"),
        name: i18next.t("models.tableStyling.label.selectableDimensions.offsetY.name"),
        value: (_labelTraits$pixelOff2 = labelTraits.pixelOffset[1]) !== null && _labelTraits$pixelOff2 !== void 0 ? _labelTraits$pixelOff2 : nullValues.pixelOffset[1],
        setDimensionValue: (stratumId, value) => {
          labelTraits.setTrait(stratumId, "pixelOffset", [labelTraits.pixelOffset[0], value !== null && value !== void 0 ? value : 0]);
        }
      }]);
    }, (_labelTraits, _nullValue, label) => label);
  }
  get trailDims() {
    return [...this.getStyleDims("Trail style", "trail", this.tableStyle.trailStyleMap, (id, trailTraits, nullValues) => {
      var _trailTraits$leadTime, _trailTraits$trailTim, _trailTraits$width, _trailTraits$resoluti, _trailTraits$polyline, _nullValues$polylineG, _trailTraits$polyline2, _nullValues$polylineG2, _trailTraits$polyline3, _nullValues$polylineG3, _trailTraits$solidCol, _nullValues$solidColo;
      return filterOutUndefined([{
        type: "numeric",
        id: "".concat(id, "-lead-time"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.leadTime.name"),
        value: (_trailTraits$leadTime = trailTraits.leadTime) !== null && _trailTraits$leadTime !== void 0 ? _trailTraits$leadTime : nullValues.leadTime,
        setDimensionValue: (stratumId, value) => {
          trailTraits.setTrait(stratumId, "leadTime", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-trail-time"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.trailTime.name"),
        value: (_trailTraits$trailTim = trailTraits.trailTime) !== null && _trailTraits$trailTim !== void 0 ? _trailTraits$trailTim : nullValues.trailTime,
        setDimensionValue: (stratumId, value) => {
          trailTraits.setTrait(stratumId, "trailTime", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-width"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.width.name"),
        value: (_trailTraits$width = trailTraits.width) !== null && _trailTraits$width !== void 0 ? _trailTraits$width : nullValues.width,
        setDimensionValue: (stratumId, value) => {
          trailTraits.setTrait(stratumId, "width", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-resolution"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.resolution.name"),
        value: (_trailTraits$resoluti = trailTraits.resolution) !== null && _trailTraits$resoluti !== void 0 ? _trailTraits$resoluti : nullValues.resolution,
        setDimensionValue: (stratumId, value) => {
          trailTraits.setTrait(stratumId, "resolution", value);
        }
      },
      // Show material traits based on materialType
      // "polylineGlow" or "solidColor"
      ...(this.tableStyle.trailStyleMap.traits.materialType === "polylineGlow" ? [{
        type: "color",
        id: "".concat(id, "-glow-color"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.growColor.name"),
        value: (_trailTraits$polyline = trailTraits.polylineGlow.color) !== null && _trailTraits$polyline !== void 0 ? _trailTraits$polyline : (_nullValues$polylineG = nullValues.polylineGlow) === null || _nullValues$polylineG === void 0 ? void 0 : _nullValues$polylineG.color,
        setDimensionValue: (stratumId, value) => {
          trailTraits.polylineGlow.setTrait(stratumId, "color", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-glow-power"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.growPower.name"),
        value: (_trailTraits$polyline2 = trailTraits.polylineGlow.glowPower) !== null && _trailTraits$polyline2 !== void 0 ? _trailTraits$polyline2 : (_nullValues$polylineG2 = nullValues.polylineGlow) === null || _nullValues$polylineG2 === void 0 ? void 0 : _nullValues$polylineG2.glowPower,
        setDimensionValue: (stratumId, value) => {
          trailTraits.polylineGlow.setTrait(stratumId, "glowPower", value);
        }
      }, {
        type: "numeric",
        id: "".concat(id, "-taper-power"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.taperPower.name"),
        value: (_trailTraits$polyline3 = trailTraits.polylineGlow.taperPower) !== null && _trailTraits$polyline3 !== void 0 ? _trailTraits$polyline3 : (_nullValues$polylineG3 = nullValues.polylineGlow) === null || _nullValues$polylineG3 === void 0 ? void 0 : _nullValues$polylineG3.taperPower,
        setDimensionValue: (stratumId, value) => {
          trailTraits.polylineGlow.setTrait(stratumId, "taperPower", value);
        }
      }] : [{
        type: "color",
        id: "".concat(id, "-solid-color"),
        name: i18next.t("models.tableStyling.trail.selectableDimensions.solidColor.name"),
        value: (_trailTraits$solidCol = trailTraits.solidColor.color) !== null && _trailTraits$solidCol !== void 0 ? _trailTraits$solidCol : (_nullValues$solidColo = nullValues.solidColor) === null || _nullValues$solidColo === void 0 ? void 0 : _nullValues$solidColo.color,
        setDimensionValue: (stratumId, value) => {
          trailTraits.solidColor.setTrait(stratumId, "color", value);
        }
      }])]);
    }, (_trail, _nullValue, label) => label), {
      type: "group",
      id: "trail-style-options",
      name: i18next.t("models.tableStyling.trail.selectableDimensions.trailStyleOptions.name"),
      isOpen: false,
      selectableDimensions: filterOutUndefined([{
        type: "select",
        id: "trail-style-options-material",
        name: i18next.t("models.tableStyling.trail.selectableDimensions.trailStyleOptions.selectableDimensions.material.name"),
        selectedId: this.tableStyle.trailStyleMap.traits.materialType,
        options: [{
          id: "solidColor",
          name: i18next.t("models.tableStyling.trail.selectableDimensions.trailStyleOptions.selectableDimensions.material.options.solidColor.name")
        }, {
          id: "polylineGlow",
          name: i18next.t("models.tableStyling.trail.selectableDimensions.trailStyleOptions.selectableDimensions.material.options.polylineGlow.name")
        }],
        setDimensionValue: (stratumId, value) => {
          var _this$getTableStyleTr49;
          if (value === "solidColor" || value === "polylineGlow") (_this$getTableStyleTr49 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr49 === void 0 || _this$getTableStyleTr49.trail.setTrait(stratumId, "materialType", value);
        }
      }])
    }];
  }
  get fillStyleDimensions() {
    return filterOutUndefined([
    // Only show color scheme selection if activeStyle exists
    this.item.activeStyle ? this.colorSchemeSelectableDim : undefined,
    // If we are in continuous realm:
    // - Display range
    this.colorSchemeType === "sequential-continuous" || this.colorSchemeType === "diverging-continuous" ? this.displayRangeDim : undefined,
    // If we are in discrete realm:
    // - Bin maximums
    this.colorSchemeType === "sequential-discrete" || this.colorSchemeType === "diverging-discrete" || this.colorSchemeType === "custom-discrete" ? this.binColorDims : undefined,
    // If we are in qualitative realm
    this.colorSchemeType === "qualitative" || this.colorSchemeType === "custom-qualitative" ? this.enumColorDims : undefined, this.additionalColorDimensions]);
  }

  /** All of the dimensions! */
  get selectableDimensions() {
    var _this$tableStyle$colo16;
    return filterOutUndefined([this.tableStyleSelectableDim, ...(this.styleType === "fill" ? this.fillStyleDimensions : []), ...(this.styleType === "point" ? this.markerDims : []), ...(this.styleType === "outline" ? this.outlineDims : []), ...(this.styleType === "label" ? this.labelDims : []), ...(this.styleType === "trail" ? this.trailDims : []), this.styleType === "point-size" ? this.pointSizeDimensions : undefined,
    // Show region mapping dimensions if using region column and showing advanced options
    this.showAdvancedOptions && this.styleType === "fill" && ((_this$tableStyle$colo16 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo16 === void 0 ? void 0 : _this$tableStyle$colo16.type) === TableColumnType.region ? this.advancedRegionMappingDimensions : undefined,
    // Show advanced table options
    ...(this.showAdvancedOptions ? this.advancedTableDimensions : [])]);
  }

  /**
   * Set `TableColorStyleTraits.binMaximums`
   *
   * If the maximum value of the dataset is greater than the last value in this array, an additional bin is added automatically (See `TableColorStyleTraits.binMaximums`)
   * Because of this, we may need to update `maximumValue` so we don't get more bins added automatically
   */
  setBinMaximums(stratumId, binMaximums) {
    var _this$getTableStyleTr50;
    if (!binMaximums) binMaximums = [...this.tableStyle.tableColorMap.binMaximums];
    const colorTraits = (_this$getTableStyleTr50 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr50 === void 0 ? void 0 : _this$getTableStyleTr50.color;
    if (binMaximums[binMaximums.length - 1] !== this.tableStyle.tableColorMap.maximumValue) {
      colorTraits === null || colorTraits === void 0 || colorTraits.setTrait(stratumId, "maximumValue", binMaximums[binMaximums.length - 1]);
    }
    colorTraits === null || colorTraits === void 0 || colorTraits.setTrait(stratumId, "binMaximums", binMaximums);
  }

  /** Clear binMaximums (which will automatically generate new ones based on numberOfBins, minimumValue and maximumValue).
   * Then set them have a sensible precision (otherwise there will be way too many digits).
   * This will also clear `minimumValue` and `maximumValue` */
  resetBinMaximums(stratumId) {
    var _this$getTableStyleTr51, _this$getTableStyleTr52, _this$getTableStyleTr53, _this$getTableStyleTr54;
    (_this$getTableStyleTr51 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr51 === void 0 || _this$getTableStyleTr51.color.setTrait(stratumId, "minimumValue", undefined);
    (_this$getTableStyleTr52 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr52 === void 0 || _this$getTableStyleTr52.color.setTrait(stratumId, "maximumValue", undefined);
    (_this$getTableStyleTr53 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr53 === void 0 || _this$getTableStyleTr53.color.setTrait(stratumId, "binMaximums", undefined);
    const binMaximums = this.tableStyle.tableColorMap.binMaximums.map(bin => {
      var _this$tableStyle$numb;
      return parseFloat(bin.toFixed((_this$tableStyle$numb = this.tableStyle.numberFormatOptions) === null || _this$tableStyle$numb === void 0 ? void 0 : _this$tableStyle$numb.maximumFractionDigits));
    });
    (_this$getTableStyleTr54 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr54 === void 0 || _this$getTableStyleTr54.color.setTrait(stratumId, "binMaximums", binMaximums);
  }

  /** Set enum value and color for specific index in `enumColors` array */
  setEnumColorTrait(stratumId, index, value, color) {
    var _this$getTableStyleTr55;
    const enumColors = this.tableStyle.colorTraits.traits.enumColors.toJson(this.tableStyle.tableColorMap.enumColors);

    // Remove element if value and color are undefined
    if (!isDefined(value) && !isDefined(color)) enumColors.splice(index, 1);else enumColors[index] = {
      value,
      color
    };
    (_this$getTableStyleTr55 = this.getTableStyleTraits(stratumId)) === null || _this$getTableStyleTr55 === void 0 || _this$getTableStyleTr55.color.setTrait(stratumId, "enumColors", enumColors);
  }

  /** Convenience getter for item.activeTableStyle */
  get tableStyle() {
    return this.item.activeTableStyle;
  }

  /** Get `TableStyleTraits` for the active table style (so we can call `setTraits`).
   */
  getTableStyleTraits(stratumId) {
    var _this$item$styles$fin, _this$item$styles;
    let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.tableStyle.id;
    if (id === "Default Style") {
      id = "User Style";
      runInAction(() => this.item.setTrait(stratumId, "activeStyle", "User Style"));
    }
    const style = (_this$item$styles$fin = (_this$item$styles = this.item.styles) === null || _this$item$styles === void 0 ? void 0 : _this$item$styles.find(style => style.id === id)) !== null && _this$item$styles$fin !== void 0 ? _this$item$styles$fin : this.item.addObject(stratumId, "styles", id);
    style === null || style === void 0 || style.setTrait(stratumId, "hidden", false);
    return style;
  }

  /** Get `TableColumnTraits` for the active table style `colorColumn` (so we can call `setTraits`) */
  getTableColumnTraits(stratumId) {
    var _this$tableStyle$colo17, _this$item$columns$fi, _this$item$columns;
    if (!((_this$tableStyle$colo17 = this.tableStyle.colorColumn) !== null && _this$tableStyle$colo17 !== void 0 && _this$tableStyle$colo17.name)) return;
    return (_this$item$columns$fi = (_this$item$columns = this.item.columns) === null || _this$item$columns === void 0 ? void 0 : _this$item$columns.find(col => col.name === this.tableStyle.colorColumn.name)) !== null && _this$item$columns$fi !== void 0 ? _this$item$columns$fi : this.item.addObject(stratumId, "columns", this.tableStyle.colorColumn.name);
  }
}, _defineProperty(_TableStylingWorkflow, "type", "table-styling"), _TableStylingWorkflow), _descriptor = _applyDecoratedDescriptor(_class.prototype, "colorSchemeType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "styleType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "fill";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "openBinIndex", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new ObservableMap();
  }
}), _applyDecoratedDescriptor(_class.prototype, "menu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setColorSchemeTypeFromPalette", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setColorSchemeTypeFromPalette"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setColorSchemeType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setColorSchemeType"), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showAdvancedOptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasCesiumDataSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCesiumDataSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasProtomapsImageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasProtomapsImageryProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tableStyleSelectableDim", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tableStyleSelectableDim"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "colorSchemesForType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "colorSchemesForType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "colorSchemeSelectableDim", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "colorSchemeSelectableDim"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minimumValueSelectableDim", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minimumValueSelectableDim"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayRangeDim", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayRangeDim"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "binColorDims", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "binColorDims"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enumColorDims", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enumColorDims"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nullColorDimension", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nullColorDimension"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "outlierColorDimension", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "outlierColorDimension"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "additionalColorDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "additionalColorDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pointSizeDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pointSizeDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advancedRegionMappingDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "advancedRegionMappingDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advancedTableDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "advancedTableDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markerDims", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "markerDims"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "outlineDims", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "outlineDims"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "labelDims", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "labelDims"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trailDims", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "trailDims"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fillStyleDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fillStyleDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectableDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectableDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tableStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tableStyle"), _class.prototype), _class);
export { TableStylingWorkflow as default };
function getColorPreview(col, label) {
  return "<div><div style=\"margin-bottom: -4px; width:20px; height:20px; display:inline-block; background-color:".concat(col, " ;\"></div> ").concat(label, "</div>");
}